import React from 'react';

const Dashboard = () => {
    return (
        <div>
            {/* DashBoard */}
            Unsubscribed. Please subsribe for more information on dashboard.
        </div>
    );
}
export default Dashboard